import React, { useContext, useMemo } from 'react';
import Dialog from '../../../../../../../BaseComponents/Dialog/EDDialog';
import KodbehorighetInfo from '../../../../../../../Components/KodbehorighetInfo/KodbehorighetInfo';
import FakturaDelContext from '../FakturaDelContextManager/FakturaDelContext';
import KonteringContext, {
  IAttestKodbehorighetUrval,
} from '../../../../../_Common/Components/KonteringManager/KonteringContext';
import mergeSort, {
  stringCompareNumeric,
} from '../../../../../../../Utils/mergeSort';
import { FakturaattestWrapperContext } from '../../../../Rutiner/FakturaDel/Contexts/FakturaattestWrapperContext';
import { ModelContext } from '../../../../../../../Model/ModelContext/ModelContext';
import { getOrdinarieKodbehorigheter } from '../Kontering/Utils/KonteringUtils';
import { LRSysOptionsQuery_db_SYSOptions_All } from '../../Queries/LRSysOptionQuery/_QueryTypes/LRSysOptionsQuery';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';

interface IProps {
  open: boolean;
  onClose: () => void;
}

const KodbehInfoModal: React.FC<React.PropsWithChildren<IProps>> = props => {
  const fakturaDelContext = useContext(FakturaDelContext);
  const fakturaattestContext = useContext(FakturaattestWrapperContext);
  const { avenyCollectionMap } = useContext(ModelContext);
  const konteringContext = useContext(KonteringContext);

  const requireMotKodbeh: boolean = useMemo(() => {
    return (
      fakturaattestContext.sysOptions?.filter(
        (option: LRSysOptionsQuery_db_SYSOptions_All) =>
          option.OptionKey === 'LR_REQUIRE_MOTKODBEH'
      )?.[0]?.OptionData === 'Y'
    );
  }, [fakturaattestContext.sysOptions]);

  const kodbehorigheturval: IAttestKodbehorighetUrval[] | undefined =
    getOrdinarieKodbehorigheter(
      fakturaattestContext.reservForKodbehorigheter,
      fakturaDelContext.minFakturaAttest,
      fakturaDelContext.kodplanId,
      avenyCollectionMap,
      konteringContext.attestKodbehorigheterUrval,
      requireMotKodbeh
    );

  const filteredSortedKodbehUrval = mergeSort(
    kodbehorigheturval?.map(kodbeh => kodbeh.urval) ?? [],
    (a, b) => {
      return stringCompareNumeric(
        a.savedUrvalProps?.namn ?? '',
        b.savedUrvalProps?.namn ?? ''
      );
    }
  );

  const getTitle = () => {
    const minFakturaAttest = fakturaDelContext.minFakturaAttest;
    let result: string | undefined;
    if (minFakturaAttest.isReserv) {
      result =
        filteredSortedKodbehUrval.length === 1
          ? `Kodbehörighet för ${minFakturaAttest.reservAttestratt.ordinareAttestant}`
          : `Kodbehörigheter för ${minFakturaAttest.reservAttestratt.ordinareAttestant}`;
    } else {
      result =
        filteredSortedKodbehUrval.length === 1
          ? filteredSortedKodbehUrval[0]?.savedUrvalProps?.namn
          : 'Dina kodbehörigheter';
    }
    return result;
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      title={getTitle()}
      footerActions={[
        {
          label: 'Stäng',
          onClick: props.onClose,
        },
      ]}
    >
      {!requireMotKodbeh &&
        (kodbehorigheturval?.length === 0 ||
          kodbehorigheturval == undefined) && (
          <EDTypography>
            Du har ingen kodbehörighet och är således behörig att kontera på
            alla tillgänliga konton
          </EDTypography>
        )}
      <KodbehorighetInfo
        kodbehorigheturval={filteredSortedKodbehUrval}
        isReserv={fakturaDelContext.minFakturaAttest.isReserv}
      ></KodbehorighetInfo>
    </Dialog>
  );
};

export default KodbehInfoModal;
